// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3nJMT","title":"ClientInsurance_title__1Cf6m","itemText":"ClientInsurance_itemText__1QdL7"};